import {Button} from '@mui/material'
import {FacebookAuthProvider, signInWithPopup } from 'firebase/auth'
import { auth } from '../../firebase/auth'
import { withFirebaseAuth } from './components/withFirebaseAuth'
import facebook from 'images/facebook.svg'

export const FacebookSignInButton = withFirebaseAuth((props) => {
  const { onSuccessfulAuth, title, ...otherProps } = props

  const onAuth = () => {
    const provider = new FacebookAuthProvider()
    signInWithPopup(auth, provider).then((result) => {
      onSuccessfulAuth()
    }).catch(console.error)
  }

  return (
    <Button onClick={onAuth} {...otherProps}>
      <img src={facebook} alt="Facebook Icon" />
      <span style={{marginLeft: '10px'}}>{title}</span>
    </Button>
  )
})
